import React from 'react';
import { Alert } from './ui';
import { isAtLeastConfirmed, recordStatus } from '../utils/verification';
import type { ItemVerificationStatus } from '../types';

export const EditResetWarning: React.FC<{ status?: ItemVerificationStatus }> = ({ status }) => {
  if (!isAtLeastConfirmed(recordStatus({ verification_status: status }))) return null;
  return (
    <Alert variant="warning" className="mb-4">
      Saving changes will reset this item to self-reported. If supporting files remain, it will
      move back to evidence supplied. It will need to be verified again.
    </Alert>
  );
};
